import { render, staticRenderFns } from "./leftnav.vue?vue&type=template&id=418a8c64&scoped=true"
import script from "./leftnav.vue?vue&type=script&lang=ts"
export * from "./leftnav.vue?vue&type=script&lang=ts"
import style0 from "./leftnav.vue?vue&type=style&index=0&id=418a8c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418a8c64",
  null
  
)

export default component.exports